import { render } from "./PassBuff.vue?vue&type=template&id=73ea502b"
import script from "./PassBuff.vue?vue&type=script&lang=js"
export * from "./PassBuff.vue?vue&type=script&lang=js"

import "./PassBuff.vue?vue&type=style&index=0&id=73ea502b&lang=css"

import exportComponent from "C:\\Users\\boyaz\\Desktop\\Sick Codes\\PassBuffFront\\passbuff\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__